import React, {useCallback, memo, useState} from "react";
import {Formik} from "formik";
import Loading from "../Loading";
import {getFormData} from "../../utils/form";
import {useRequest} from "../../hooks/request.hook";
import CustomAlert from "../Alert";

const Form = ({
                  method,
                  action,
                  format,
                  transformValues,
                  validationSchema,
                  initialValues,
                  onSuccess,
                  onError,
                  className,
                  children,
                  withoutToken = false,
                  noEnter = false,
                  resetForm = false
              }) => {
    const [showAlert, setShowAlert] = useState(false);
    const {loading, request, errors, clearError} = useRequest();
    const isMultipartData = format === "multipart/form-data";

    const formatData = useCallback(values => {
        const data = transformValues ? transformValues(values) : values;

        return isMultipartData ? getFormData(data) : JSON.stringify(data);
    }, [transformValues, isMultipartData]);

    const onSubmit = async (values, actions) => {
        const onRequestSuccess = data => {
            actions.setSubmitting(false);
            if (resetForm) actions.resetForm(initialValues);
            setShowAlert(true);
            onSuccess && onSuccess(data, values);
        };

        const onRequestError = error => {
            actions.setSubmitting(false);
            onError && onError(error);
            if(error.isAxiosError && error.response.data.errors) {
                actions.setErrors(error.response.data.errors);
            }
        };

        const options = {
            url: action,
            method,
            data: formatData(values),
            isMultipart: isMultipartData,
            withoutToken
        };

        await request(options, onRequestSuccess, onRequestError);
    };

    Object.keys(initialValues).forEach(key => {
        if (initialValues[key] === null) initialValues[key] = '';
    });

    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
        >
            {({handleSubmit}) =>
                loading ?
                    <Loading centered={false} /> :
                    <>
                        <form
                            onKeyDown={noEnter ? e => e && e.key === 'Enter' && e.preventDefault() : null}
                            className={`form${className ? ' ' + className : ''}`}
                            onSubmit={handleSubmit}
                        >
                            {children}
                        </form>
                        {!!errors.length && !onError &&
                            errors.map((error, i) =>
                                <CustomAlert
                                    key={`error-${i}`}
                                    message={error}
                                    severity="error"
                                    onClose={() => clearError()}
                                />
                            )
                        }
                        {showAlert &&
                            <CustomAlert
                                message="Ваши данные успешно изменены"
                                severity="success"
                                onClose={() => setShowAlert(false)}
                            />
                        }
                    </>
            }
        </Formik>
    )
};

export default memo(Form);